module.exports = __webpack_public_path__ + "img/search-active.14e18fae.svg";